// Extra 7 — 4 Numéros Boost winnings grid (à propos page).
// Each result row pays a cash amount per Boost tier plus a fixed FreeBet.
// Amounts are pre-formatted display strings (space thousands separator, GNF
// appended in the template) to match the printed marketing grid exactly.

export interface Extra7BoostRow {
    // count of correct numbers (out of 4) — fed to the translated row label
    count: number;
    // cash win per tier, same order as `extra7BoostTiers`
    cash: string[];
    // FreeBet amount granted on this result (same for every tier)
    freebet: string;
}

// Boost tiers, left-to-right (translation keys)
export const extra7BoostTiers: string[] = ["boost", "super boost", "mega boost"];

export const extra7BoostGains: Extra7BoostRow[] = [
    { count: 2, cash: ["35 000", "40 000", "50 000"], freebet: "9 000" },
    { count: 3, cash: ["450 000", "600 000", "1 000 000"], freebet: "9 000" },
    { count: 4, cash: ["20 000 000", "26 000 000", "40 000 000"], freebet: "9 000" },
];
